<template>
  <div class="flex q-gutter-y-lg full-width">
    <template v-for="sec in sections" :key="sec.name">
      <div v-if="sec.extras?.length" class="full-width">
        <div class="font-fjalla-one q-pl-xs text-uppercase text-muted">{{ sec.name }}</div>
        <q-card bordered flat class="overflow-hidden">
          <div class="flex column c-row-wrapper">
            <div v-for="extra in sec.extras" :key="extra.slug" class="q-pa-xs full-width c-rows">
              <div class="flex full-width q-col-gutter-x-xs items-center">
                <div>
                  <q-icon name="check"/>
                </div>

                <div>{{ extra.icon }}</div>

                <div>{{ extra.name }}</div>

                <div>
                  <template v-if="figures.hasOwnProperty(extra.slug)">
                    <div v-if="figures[extra.slug]?.length" class="flex q-gutter-xs">
                      <q-badge
                        v-for="fig in figures[extra.slug]" :key="fig.field"
                        color="grey-7" outline>
                        {{ fig.value }} {{ fig.dimension }}
                      </q-badge>
                    </div>
                  </template>
                </div>

                <div
                    v-if="extra.description" class="col-grow text-small q-px-sm text-muted"
                     style="word-wrap: break-word;">
                  {{ extra.description }}
                </div>

              </div>

            </div>
          </div>
        </q-card>
      </div>
    </template>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';
import {extraMapping, getExtraFigures} from 'src/etc/helper';

const figures = ref({})

const props = defineProps({
  advert: Object
})

const getFigures = function () {
  props.advert.vehicle.extras.forEach(obj => {
    const _fig = getExtraFigures(obj.slug, props.advert)
    figures.value[obj.slug] = _fig
  })
}
getFigures()

const sections = computed(() => {
  return extraMapping(props.advert.vehicle.extras)
})
</script>

<style lang="scss" scoped>
.c-rows {
  &:nth-child(even) {
    background-color: $grey-2;
    clip: auto;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
}
</style>
